import { render, staticRenderFns } from "./ServiceTypeNotification.vue?vue&type=template&id=77f81f30&scoped=true&"
import script from "./ServiceTypeNotification.vue?vue&type=script&lang=ts&"
export * from "./ServiceTypeNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTypeNotification.vue?vue&type=style&index=0&id=77f81f30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f81f30",
  null
  
)

export default component.exports